// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"devices_wrapper__2Fk8y","buttons":"devices_buttons__20Uo8"};